export enum DateClauseType {
	RelativeCurrentDate,
	RelativeDateRange,
	ExactDate,
	CurrentWeek,
	CurrentMonth,
	WeekNumber,
	YearToDate,
	DateRange,
	MonthRange,
	CurrentQuarter,
	PreviousWeek,
	NextWeek
}
